<ng-template #closeButtonRef>
  <img
    src="/assets/svg/ico-hamburger-close.svg"
    class="cross-button pointer-cursor"
    (click)="closeDialog()"
  />
</ng-template>

<div class="modal-main" [formGroup]="formGroup">
  <!-- Preserve the details ViewChild and its edit mode while a local editor is open. -->
  <div [hidden]="stepper !== 1">
    <app-user-profile-details
      formGroupName="userDetails"
      [profileDetails]="profileDetails"
      [ownProfile]="ownProfile"
      [sharedData]="sharedData"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      (stepperChange)="stepper = $event; assignAccessBackStep = 19"
      [groupTypeName]="groupTypeName"
      [userGroupId]="userGroupId"
      [(flowType)]="flowType"
      [userNotHaveExistingGroup]="userNotHaveExistingGroup"
      [removeFromUnit]="removeFromUnit"
      [unitId]="unitId"
      [unitName]="unitName"
    >
    </app-user-profile-details>
  </div>
  <ng-container *ngIf="stepper === 2">
    <app-user-profile-access
      [profileDetails]="profileDetails"
      userDetailsFormGroupName="userDetails"
      (removeUserAccessHandler)="removeUserAccessHandler($event)"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [ownProfile]="ownProfile"
      accessTimeFormGroupName="shareAccessTime"
      [(selectedAccess)]="selectedAccess"
      [userId]="userId"
      [accessIds]="accessIds"
      [(flowType)]="flowType"
      [assigningAccess]="assigningAccess"
      (addNewAccess)="addNewAccess()"
    ></app-user-profile-access>
  </ng-container>
  <ng-container *ngIf="stepper === 3">
    <app-user-profile-groups
      [profileDetails]="profileDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedGroup)]="selectedGroup"
      [(deleteGroupFlag)]="deleteGroupFlag"
      accessTimeFormGroupName="accessTime"
      [ownProfile]="ownProfile"
      [userGroups]="profileDetails.userGroups"
    ></app-user-profile-groups>
  </ng-container>
  <ng-container *ngIf="stepper === 4">
    <app-user-profile-access-time
      formGroupName="accessTime"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [profileDetails]="profileDetails"
      [ownProfile]="ownProfile"
      [userId]="userId"
      [(addGroupFlag)]="addGroupFlag"
      [(deleteGroupFlag)]="deleteGroupFlag"
      (submitToUserProfile)="submitToUserProfile($event)"
      [parentRouteParams]="parentRouteParams"
      [selectedGroup]="selectedGroup"
    >
      <span closeButton>
        <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
      </span>
    </app-user-profile-access-time>
  </ng-container>
  <ng-container *ngIf="stepper === 5">
    <app-user-profile-physical-credentials
      [profileDetails]="profileDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      userDetailsFormGroupName="userDetails"
      [userCredentials]="userCredentials"
    ></app-user-profile-physical-credentials>
  </ng-container>
  <ng-container *ngIf="stepper === 11">
    <app-resend-invitation
      [email]="email"
      [siteId]="sharedData?.selectedSite?.siteId"
      [(stepper)]="stepper"
    ></app-resend-invitation>
  </ng-container>
  <ng-container *ngIf="stepper === 12">
    <app-resend-success
      [SuccessMessage]="'INVITATION_RESENT_SUCCESSFULLY' | translate"
      layoutType="invitation"
      [dialogRef]="dialogRef"
    ></app-resend-success>
  </ng-container>
  <ng-container *ngIf="stepper === 6">
    <app-user-profile-activity
      [profileDetails]="profileDetails"
      [userActivities]="userActivitiesNew"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedActivity)]="selectedActivity"
      (getMyLastActivity)="getMyLastActivity($event)"
      userDetailsFormGroupName="userDetails"
      [ownProfile]="ownProfile"
    ></app-user-profile-activity>
  </ng-container>
  <ng-container *ngIf="stepper === 7">
    <div
      class="user-activity d-flex flex-column h-100 w-100 justify-content-center px-4 py-4 modal-main"
    >
      <app-user-profile-group
        class="user-profile-user-group"
        [userStepper]="stepper"
        (userStepperChange)="userStepperChange($event)"
        [userGroup]="userGroup"
        (userGroupChange)="userGroupChange($event)"
        [(selectedGroup)]="selectedGroup"
        formGroupUserDetailName="userDetails"
        [skipStepUserType]="skipStepUserType"
        [skipStepBuilding]="skipStepBuilding"
        [preSelectedGroups]="profileDetails?.userGroups"
        [siteTimeZone]="siteTimeZone"
        [profileDetails]="profileDetails"
        (submitUserGroupToParent)="getUpdatedUserGroups($event)"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
        </span>
      </app-user-profile-group>
    </div>
  </ng-container>

  <ng-container *ngIf="stepper === 8">
    <app-user-profile-access-time-update
      formGroupName="shareAccessTime"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [selectedGroup]="selectedGroup"
      [profileDetails]="profileDetails"
      [ownProfile]="ownProfile"
      [selectedAccess]="selectedAccess"
      (submitToUserProfileEmitter)="submitToUserProfileEmitter($event)"
      [parentRouteParams]="parentRouteParams"
      userDetails="userDetails"
    >
      <span closeButton>
        <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
      </span>
    </app-user-profile-access-time-update>
  </ng-container>

  <ng-container *ngIf="stepper >= 8">
    <app-completed
      [class.d-block]="stepper === 9"
      class="d-none"
      [dialogRef]="dialogRef"
      isAccessComplete="true"
      [headerTitleKey]="
        assignAccessBackStep === 2 && flowType === ''
          ? 'PROFILE_POPUP_CONFIRM_ACCESS'
          : 'ACCESS_COMPLETED_ACCESS_UPDATED'
      "
      [(stepper)]="stepper"
      [(flowType)]="flowType"
      (formReset)="formReset()"
    >
    </app-completed>
  </ng-container>

  <ng-container *ngIf="stepper === 10">
    <app-user-profile-groups-without-scheduler
      [profileDetails]="profileDetails"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedGroup)]="selectedGroup"
      [(deleteGroupFlag)]="deleteGroupFlag"
      accessTimeFormGroupName="accessTime"
      [ownProfile]="ownProfile"
      [userGroupList]="userGroupList"
      (userGroupListChange)="userGroupListChange($event)"
    ></app-user-profile-groups-without-scheduler>
  </ng-container>

  <ng-container *ngIf="stepper === 15">
    <app-edit-phone-number
      [(stepper)]="stepper"
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
    ></app-edit-phone-number>
  </ng-container>

  <ng-container *ngIf="stepper === 17">
    <app-profile-edit
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [fullEdit]="profileDetailsRef?.canEditFullProfile"
      [editField]="profileDetailsRef?.editField"
      [nextStep]="
        profileDetailsRef?.editField === 'phone' &&
        profileDetailsRef?.userStatus === 'pendingActivation'
          ? 16
          : 1
      "
      (profileUpdated)="refreshProfileAfterEdit($event)"
      (openProfile)="openAssignDuplicateProfile($event)"
      (mergedNeedsAccess)="continueAssignAfterMerge($event)"
    ></app-profile-edit>
  </ng-container>

  <ng-container *ngIf="stepper === 18">
    <app-profile-mobile-access
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [fullEdit]="profileDetailsRef?.canEditFullProfile"
      (profileUpdated)="refreshProfileAfterEdit($event)"
    ></app-profile-mobile-access>
  </ng-container>

  <ng-container *ngIf="stepper === 19">
    <app-profile-assign-user-type
      [dialogRef]="dialogRef"
      [profileDetails]="profileDetails"
      [(stepper)]="stepper"
      [(selectedType)]="assignUserType"
      [allowedTypes]="mergedAccessTypes"
      [siteId]="sharedData?.selectedSite?.siteId"
      (buildingsLoaded)="assignBuildings = $event"
    ></app-profile-assign-user-type>
  </ng-container>

  <ng-container *ngIf="stepper === 20">
    <app-profile-assign-building
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [buildings]="assignBuildings"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      (stepperChange)="onAssignBuildingStepChange($event)"
      [(selectedBuilding)]="assignBuilding"
      (floorsLoaded)="assignFloors = $event; assignUnits = []; assignLocks = []"
    ></app-profile-assign-building>
  </ng-container>

  <ng-container *ngIf="stepper === 33">
    <app-profile-access-unit-list
      [profileDetails]="profileDetails"
      [building]="assignBuilding"
      [floors]="assignFloors"
      [dialogRef]="dialogRef"
      (stepperChange)="stepper = $event"
      (unitSelected)="selectAccessUnit($event)"
    ></app-profile-access-unit-list>
  </ng-container>

  <ng-container *ngIf="stepper === 34">
    <app-profile-access-lock-list
      [profileDetails]="profileDetails"
      [unit]="assignUnits[0]"
      [building]="assignBuilding"
      [floors]="assignFloors"
      [(selectedLocks)]="assignLocks"
      (continueRequested)="reviewSelectedLocks($event)"
      [dialogRef]="dialogRef"
      (stepperChange)="stepper = $event"
    ></app-profile-access-lock-list>
  </ng-container>

  <ng-container *ngIf="stepper === 21">
    <app-profile-assign-unit
      [profileDetails]="profileDetails"
      [building]="assignBuilding"
      [floors]="assignFloors"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      [(selectedUnits)]="assignUnits"
    ></app-profile-assign-unit>
  </ng-container>

  <ng-container *ngIf="stepper === 22 || stepper === 35">
    <app-profile-review-access
      [profileDetails]="profileDetails"
      [building]="assignBuilding"
      [floors]="assignFloors"
      [selectedUnits]="assignUnits"
      [reviewMode]="stepper === 35 ? 'locks' : 'units'"
      [selectedLocks]="assignLocks"
      (continueRequested)="continueLockReview($event)"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    ></app-profile-review-access>
  </ng-container>

  <!-- Profile dialog opens with space-zero; restore the 24px padding app-access-time expects. -->
  <div *ngIf="stepper === 23" class="px-4 py-4">
    <app-access-time
      formGroupName="assignAccessTime"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      (stepperChange)="onAssignAccessTimeStepChange($event)"
      headerTitleKey="PROFILE_POPUP_ADD_ACCESS"
      subtitleKey="PROFILE_POPUP_ACCESS_TIME_SUBTITLE"
      timeFormTitleKey="PROFILE_POPUP_ASSIGN_TIME"
      [timeZoneLabel]="siteTimeZone || ''"
      [showSkip]="false"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="closeButtonRef"></ng-template>
      </span>
    </app-access-time>
  </div>

  <ng-container *ngIf="stepper === 24">
    <app-profile-confirm-access
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [userType]="assignUserType"
      [building]="assignBuilding"
      [floors]="assignFloors"
      [selectedUnits]="assignUnits"
      [reviewMode]="assignAccessBackStep === 2 ? 'locks' : 'units'"
      [selectedLocks]="assignLocks"
      [accessTime]="formGroup.get('assignAccessTime')?.value"
      [timeZone]="siteTimeZone || ''"
      [siteName]="sharedData?.selectedSite?.siteName || ''"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (editProfileRequested)="confirmAccessEdit = true"
      (profileUpdated)="refreshProfileAfterEdit($event)"
      (lockAccessAdded)="onLockAccessAdded()"
    ></app-profile-confirm-access>
  </ng-container>

  <ng-container *ngIf="stepper === 26">
    <app-profile-access-assigned
      [profileDetails]="profileDetails"
      (viewProfile)="viewProfileAfterAccess()"
      (addAnotherUser)="addAnotherUserAfterAccess()"
    ></app-profile-access-assigned>
  </ng-container>

  <!-- Edit Information from Confirm Access always returns to Confirm Access. -->
  <ng-container *ngIf="stepper === 25">
    <app-profile-edit
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      (stepperChange)="stepper = 24"
      [fullEdit]="profileDetailsRef?.canEditFullProfile"
      editField="profile"
      [confirmAccessEdit]="true"
      (profileUpdated)="refreshProfileAfterEdit($event)"
      (openProfile)="openAssignDuplicateProfile($event)"
      (mergedNeedsAccess)="continueAssignAfterMerge($event)"
    ></app-profile-edit>
  </ng-container>

  <ng-container *ngIf="stepper === 27">
    <app-profile-edit
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      [fullEdit]="true"
      editField="profile"
      [completeInfo]="true"
      [backStep]="19"
      [nextStep]="assignUserType === 1 || assignUserType === 2 ? 24 : 20"
      [confirmAccessEdit]="confirmAccessEdit"
      (stepperChange)="onCompleteInfoStepChange($event)"
      (profileUpdated)="refreshProfileAfterEdit($event)"
      (openProfile)="openAssignDuplicateProfile($event)"
      (mergedNeedsAccess)="continueAssignAfterMerge($event)"
    ></app-profile-edit>
  </ng-container>

  <ng-container *ngIf="stepper === 30">
    <app-profile-edit
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
      [fullEdit]="true"
      editField="profile"
      [mobileSetupMode]="true"
      (stepperChange)="stepper = $event"
      (profileUpdated)="refreshProfileAfterEdit($event)"
      (openProfile)="openAssignDuplicateProfile($event)"
      (mergedNeedsAccess)="continueAssignAfterMerge($event)"
    ></app-profile-edit>
  </ng-container>

  <ng-container *ngIf="stepper === 31">
    <app-profile-mobile-confirm-access
      [profileDetails]="profileDetails"
      [siteId]="sharedData?.selectedSite?.siteId"
      [timeZone]="siteTimeZone || ''"
      [dialogRef]="dialogRef"
      (backRequested)="stepper = 30"
      (inviteSent)="stepper = 32"
    ></app-profile-mobile-confirm-access>
  </ng-container>

  <ng-container *ngIf="stepper === 28">
    <app-profile-mobile-invite-sent
      [profileDetails]="profileDetails"
      (viewProfile)="viewProfileAfterAccess()"
      (addAnotherUser)="addAnotherUserAfterAccess()"
    ></app-profile-mobile-invite-sent>
  </ng-container>

  <ng-container *ngIf="stepper === 32">
    <app-profile-mobile-invite-sent
      [profileDetails]="profileDetails"
      (viewProfile)="viewProfileAfterAccess()"
      (addAnotherUser)="addAnotherUserAfterAccess()"
    ></app-profile-mobile-invite-sent>
  </ng-container>

  <ng-container *ngIf="stepper === 16">
    <app-resend-success
      [SuccessMessage]="'PHONE_UPDATED' | translate"
      [headerTitle]="'USER_PROFILE' | translate"
      [dialogRef]="dialogRef"
      [stepper]="stepper"
    ></app-resend-success>
  </ng-container>

  <ng-container *ngIf="stepper === 13">
    <app-pending-account-deletion
      [autoDeactivationDate]="profileDetails?.autoDeactivationDate"
      [userName]="
        (profileDetails?.firstName || '') +
        ' ' +
        (profileDetails?.lastName || '')
      "
      [(stepper)]="stepper"
      (removeUserAction)="onRemoveUserFromDeletion()"
      (rejectDeletionAction)="onRejectDeletion()"
    ></app-pending-account-deletion>
  </ng-container>

  <ng-container *ngIf="stepper === 14">
    <app-account-reactivated
      [dialogRef]="dialogRef"
      [userName]="
        (profileDetails?.firstName || '') +
        ' ' +
        (profileDetails?.lastName || '')
      "
    ></app-account-reactivated>
  </ng-container>
</div>
